<template>
  <div style="padding-left:5px;padding-right:5px;">
    <ConfirmDialog
      :dialog="showConfirmDelete"
      @modalResult="confirmDeleteMessageDialogResult"
      title="Delete Message"
      :text=getDeleteText()
      yesColor=""
    >
    </ConfirmDialog>

    <EditMessageDialog
      :dialog="showEditMessageDialog"
      :id="getId()"
      :startDate="getStartDate()"
      :endDate="getEndDate()"
      :header="getHeader()"
      :body="getBody()"
      :market="getMarket()"
      :callToAction="getCallToAction()"
      @close="closeEditMessageDialog"
    >
    </EditMessageDialog>

    <v-data-table
      class="mt-5"
      single-select
      :footer-props="{ disableItemsPerPage: true, }"
      :headers="headers"
      :loading="busy"
      :items="messages"
      :items-per-page="10"
      :server-items-length="serverItemsLength"
      :options.sync="options"
    >
      <template v-slot:item.action="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon small class="mr-2" @click.stop="openEditMessageDialog(item)" v-on="on">edit</v-icon>
          </template>
          <span>Edit Message</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon small class="mr-2" @click.stop="openConfirmDeleteMessageDialog(item)" v-on="on">delete</v-icon>
          </template>
          <span>Delete Message</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import moment from 'moment';
import ConfirmDialog from '../ConfirmDialog.vue';
import EditMessageDialog from '@/components/messaging/EditMessageDialog.vue';

export default {
  components: {
    ConfirmDialog,
    EditMessageDialog,
  },

  data() {
    return {
      headers: [
        {
          text: 'ID',
          align: 'left',
          sortable: false,
          value: 'id',
          width: 75,
        },
        {
          text: 'Header',
          align: 'left',
          sortable: false,
          value: 'header',
          width: 350,
        },
        {
          text: 'Market',
          align: 'left',
          sortable: false,
          value: 'targets.market',
          width: 75,
        },
        {
          text: 'Start Date',
          align: 'left',
          sortable: false,
          value: 'schedule.startDate',
          width: 100,
        },
        {
          text: 'End Date',
          align: 'left',
          sortable: false,
          value: 'schedule.endDate',
          width: 100,
        },
        {
          text: 'Actions',
          align: 'left',
          sortable: false,
          value: 'action',
          width: 100,
        },
      ],
      options: {},
      message: {},
      busy: false,
      serverItemsLength: 0,
      showConfirmDelete: false,
      showEditMessageDialog: false,
    };
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },

  mounted() {
    this.getData();
  },

  methods: {
    getData() {
      const options = {
        method: 'get',
        url: `/read/messages/v1/?page=${this.options.page || 1}&filterIssuerUsername=${this.$store.state.auth.token.user.username}&invert=false&filterDisposition=draft`,
      };

      this.busy = true;

      this.axios(options)
        .then((res) => {
          this.busy = false;
          this.serverItemsLength = res.data.totalDocs;
          this.messages = res.data.docs.map((cur) => {
            const { schedule, ...rest } = cur;
            return {
              schedule: {
                startDate: moment.utc(schedule.startDate).format('M/D/YYYY h:mm A'),
                endDate: moment.utc(schedule.endDate).format('M/D/YYYY h:mm A'),
              },
              ...rest,
            };
          });
        })
        .catch((err) => {
          this.busy = false;
        });
    },

    getDeleteText() {
      return (`Are you sure you want to delete the message with ID ${this.message.id}?`);
    },

    openConfirmDeleteMessageDialog(message) {
      this.message = message;
      this.showConfirmDelete = true;
    },

    confirmDeleteMessageDialogResult(confirmed) {
      if (confirmed) {
        const options = {
          method: 'post',
          url: '/delete/message/v1',
          data: {
            id: this.message.id,
          },
        };

        this.axios(options)
          .then((res) => {
            this.showConfirmDelete = false;
            this.message = {};

            this.getData();
          });
      } else {
        this.showConfirmDelete = false;
        this.message = {};
      }
    },

    openEditMessageDialog(message) {
      this.message = message;
      this.showEditMessageDialog = true;
    },

    closeEditMessageDialog() {
      this.getData();
      this.showEditMessageDialog = false;
    },

    getStartDate() {
      let startDate = null;
      if (this.message && this.message.schedule) {
        startDate = moment.utc(this.message.schedule.startDate).format('YYYY-MM-DD');
      }
      return startDate;
    },

    getEndDate() {
      let endDate = null;
      if (this.message && this.message.schedule) {
        endDate = moment.utc(this.message.schedule.endDate).format('YYYY-MM-DD');
      }
      return endDate;
    },

    getHeader() {
      let header = null;
      if (this.message && this.message.header) {
        header = this.message.header;
      }
      return header;
    },

    getBody() {
      let body = null;
      if (this.message && this.message.body) {
        body = this.message.body;
      }
      return body;
    },

    getCallToAction() {
      let callToAction = null;
      if (this.message && this.message.callToAction) {
        callToAction = this.message.callToAction;
      }
      return callToAction;
    },

    getMarket() {
      let market = null;
      if (this.message && this.message.targets) {
        market = this.message.targets.market;
      }
      return market;
    },

    getId() {
      let id = null;
      if (this.message && this.message.id) {
        id = this.message.id;
      }
      return id;
    },
  },
};
</script>
